import { Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { useAuthStore } from '../store/useAuthStore';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';

const { Title } = Typography;

export default function AuthLayout() {
  const { isAuthenticated } = useAuthStore();
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation('common');

  // Ensure navigation logic runs in an effect
  useEffect(() => {
    if (isAuthenticated && location.pathname === '/') {
      navigate('/dashboard', { replace: true });
    }
  }, [isAuthenticated, location.pathname, navigate]);

  return (
    <div className="flex flex-row items-center justify-center h-screen relative">
      {/* Left section */}
      <div className="hidden md:flex-grow h-full order-1 md:flex flex-col justify-center items-center rounded-lg bg-purple-50">
        <div className="mb-4 text-center">
          <Title level={3} className="mb-0! text-[#2E405E] text-4xl font-bold">
            {t('energyInMotion')}
          </Title>
          <Title level={3} className="mb-0! text-[#2E405E] text-4xl font-bold">
            {t('fastSmartEverywhere')}
          </Title>
        </div>

        <div className="flex justify-center bg-blend-luminosity">
          <img
            alt="EV illustration"
            height={400}
            src={'/Electric car-amico.svg'}
            width={400}
          />
        </div>
      </div>

      {/* Right section (auth form) */}
      <div className="w-full md:w-1/3 order-2 flex items-center flex-1 h-full rounded-lg shadow-lg">
        <div className="w-full p-8 ">
          {/* Logo Section */}
          {/* <div className="mb-6 flex justify-center">
            <img
              src={settings?.companyLogoPath || '/placeholder.webp'}   // Replace with your logo path
              alt="Company Logo"
              className="h-12 w-auto" // keeps it professional
            />
          </div> */}

          {/* Outlet (login/register forms) */}
          <Outlet />
        </div>
      </div>
    </div>
  );
}
